<template>
  <div>
    <div class="top"></div>
    <!-- middle -->
    <div class="middle">
      <div class="item">
        <div class="left">
          <h1>超过<i style="color: #2956ff;">3000+</i>案例高端定制</h1>
          <p>覆盖零售、互联网拍卖、电商、物联网软件、线上教育、</p>
          <div class="icons">
            <img src="../../assets/1.png" />
            <img src="../../assets/2.png" />
            <img src="../../assets/3.png" />
            <img src="../../assets/4.png" />
            <img src="../../assets/5.png" />
            <img src="../../assets/6.png" />
            <img src="../../assets/7.png" />
            <img src="../../assets/8.png" />
            <img src="../../assets/9.png" />
            <img src="../../assets/10.png" />
            <img src="../../assets/1.png" />
            <img src="../../assets/2.png" />
          </div>
        </div>
        <div class="right">
          <h1>获取方案</h1>
          <p>完善您的信息，方便我们为您提供更好的业务方案</p>
          <a-form-model :model="form" layout="vertical">
            <a-form-model-item label="姓名">
              <a-input v-model="form.name" />
            </a-form-model-item>
            <a-form-model-item label="手机">
              <a-input v-model="form.phone" />
            </a-form-model-item>
            <a-form-model-item label="备注">
              <a-input v-model="form.remark" />
            </a-form-model-item>
          </a-form-model>
          <a-form-model-item class="login-form-button">
            <a-button type="primary" @click="submit">
              提交
            </a-button>
          </a-form-model-item>
        </div>
      </div>
    </div>
   
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      form: {}
    }
  },
  watch: {},
  created() { },
  mounted() { },
  methods: {
    submit() {
      console.log(this.form)
    }
  },
}

</script>
<style>
html,
body {
  width: 100%;
  height: 100%;
  background-color: #f2f2f2 !important;
}

.login-form-button {
  text-align: center;

  button {
    width: 40%;
  }

  width: 100%;
}
</style>

<style lang='scss' scoped>
.footer-node {
  background: url("../../assets/bg.Du78Z1_B.png") no-repeat;
  background-position: 50% 50%;
  background-size: cover;
  height: 338px;
  overflow: hidden;
  cursor: pointer;

  .footer-node-2 {
    display: flex;
    justify-content: space-around;

    .footer-node-2-qrCode {
      display: flex;
      justify-content: flex-start;

      .footer-node-2-qrCode-item {
        margin-right: 15px;

        .footer-node-2-qrCode-item-desc {
          color: #ffff;
          font-size: 10px;
        }

        .footer-node-2-qrCode-item-img {
          margin-bottom: 10px;

          img {
            width: 73px;
          }
        }
      }
    }
  }

  .footer-node-1 {
    margin-top: 50px;
    margin-bottom: 16px;

    .footer-node-1-btn {
      width: 150px;
      height: 40px;
    }

    .footer-node-1-title {
      font-size: 32px;
      color: #ffff;
      font-weight: 500;
      text-align: center;
    }
  }
}

.middle {
  background-color: #fff;
  margin: 20px 0px;

  .item {
    width: 60%;
    margin: 0px auto;
    padding: 80px 0px;
    display: flex;
    justify-content: space-between;

    h1 {
      width: 100%;
    }

    p {
      width: 100%;
    }

    .left {
      text-align: start;
      width: 75%;

      .icons {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;


        img {
          margin: 0px 10px;
          width: 200px;
        }
      }
    }

    .right {
      width: 50%;
      flex-grow: 1;
      text-align: start;

      h1 {
        margin-top: 100px;
        font-weight: 600;
      }

      .ant-input {
        height: 40px;
        line-height: 40px;
      }

    }
  }
}

.top {
  height: 65px;

}

@media screen and (max-width: 768px) {
  .middle{
    margin-top: 0px !important;
  }
  .top{
    height: 0px !important;
  }
  .item {
    width: 90% !important;
    margin: 0px auto !important;
    padding: 80px 0px !important;
    display: flex !important;
    justify-content: space-between !important;
    flex-wrap: wrap !important;
    .left{
      width: 100% !important;
      .icons{
        img{
          width: 150px !important;
        }
      }
    }
  }

  .footer-node .footer-node-1 .footer-node-1-title {
    font-size: 12px;
    color: white;
    font-weight: 500;
    text-align: center;
  }
}
</style>